import React from 'react'
import CopyToClipboard from 'react-copy-to-clipboard'

require('../style/css/third_party/foundation.css')
require('../style/css/third_party/animate.css')

require('../style/scss/custom/main.scss')

require('../style/css/custom/components/aboutMe.css')
require('../style/css/custom/main.css')

require('../js_animations/customAnimations.js')
require('../js_animations/scrollMagic.js')


const AboutMe = ({
  myEmail,
  myPhone,
  logo_white_PNG,
  logo_blue_PNG_960,
  logo_blue_PNG_100,
  logo_blue_PNG_70,
  logo_blue_PNG_16,

  copiedMessageClass_3,
  copiedMessageClass_2,
  contactMeToggle_2,

  onCopy,
  contactButtonClicked_aboutMe,
  contactButtonHover_ON_skills,
  contactButtonHover_OFF_skills,
  contactButtonClicked_skills

}) => (

<div className="about" id="about">



  {
  // Description
  }
  <div className="description_3 " data-wow-offset="350" id="about_me_description">


    {
    // links
    }
    <p className="links">
      <a href="https://www.linkedin.com/in/soniclouds/"><img className="link_images " data-wow-offset="450" src="https://s3-us-west-1.amazonaws.com/soniclouds-portfolio-assets/icons/Social/LinkedIn_1.png" alt="linkedin_link"/></a>
      <a href="https://github.com/soniclouds?tab=repositories"><img className="link_images" data-wow-offset="410" src="https://s3-us-west-1.amazonaws.com/soniclouds-portfolio-assets/icons/GitHub_11__color.png" alt="github_link"/></a>
    </p>
    {
    // Portraits
    }

    <p id="about_me__portrait" className="" data-wow-offset="100">
    {
    //   <img className="portrait" id="portrait_1" src="https://s3-us-west-1.amazonaws.com/soniclouds-portfolio-assets/Portraits/Portrait_1.jpg" alt="portrait_1"/>
    }
      <img className="portrait" id="portrait_2" src="https://s3-us-west-1.amazonaws.com/soniclouds-portfolio-assets/Portraits/Portrait_2.jpg" alt="portrait_2"/>
    </p>
    {
    // email button (CLICK TO COPY)
    }
    <div className="about_me__email_button">
      <div id='copiedMessage_aboutMe'>
        <span className={copiedMessageClass_3} id="copiedMessageSpan_AboutMe">copied {myEmail} to clipboard</span>
      </div>
      <CopyToClipboard text={myEmail} onCopy={onCopy}>
        <a ><img id="about_me__email_button" src="https://s3-us-west-1.amazonaws.com/soniclouds-portfolio-assets/icons/Email_1.png" alt="email_copyclick" className="description__contact_button wow fadeIn" data-wow-offset="50" onClick={contactButtonClicked_aboutMe} /></a>
      </CopyToClipboard>
    </div>



    <p className="p_med">
      Hello!
    </p>
    <p className="p_big">
      I help individuals, businesses and organizations create beautiful and engaging interfaces that optimize their value and empower our world.
    </p>
    <p>
      <a href="http://www.linkedin.com/in/soniclouds">Let’s work together</a>
    </p>








  </div>


{/*
  <div className="about_me__text" id="about_me__text">

    {
    // Header
    // }

    <div className="about_me__text_header">
      <p className="wow bounceInUp " data-wow-offset="0">A</p><p className="wow bounceInUp  " data-wow-offset="100">B</p><p className="wow bounceInUp  " data-wow-offset="110">O</p><p className="wow bounceInUp  " data-wow-offset="120">U</p><p className="wow bounceInUp  " data-wow-offset="130">T</p> <p className="wow bounceInUp  " data-wow-offset="150">M</p><p className="wow bounceInUp  " data-wow-offset="160">E</p>
    </div>
    {
    // links
    }
    <p className="links">
      <a href="https://www.linkedin.com/in/soniclouds/"><img className="link_images wow fadeIn" data-wow-offset="450" src="https://s3-us-west-1.amazonaws.com/soniclouds-portfolio-assets/icons/Social/LinkedIn_1.png" alt="linkedin_link"/></a>
      <a href="https://github.com/soniclouds?tab=repositories"><img className="link_images wow fadeIn" data-wow-offset="410" src="https://s3-us-west-1.amazonaws.com/soniclouds-portfolio-assets/icons/GitHub_11__color.png" alt="github_link"/></a>
    </p>
    {
    // Portraits
    }
    <p id="about_me__portrait" className="wow fadeIn" data-wow-offset="100">
      <img className="portrait" id="portrait_1" src="https://s3-us-west-1.amazonaws.com/soniclouds-portfolio-assets/Portraits/Portrait_1.jpg" alt="portrait_1"/>
      <img className="portrait" id="portrait_2" src="https://s3-us-west-1.amazonaws.com/soniclouds-portfolio-assets/Portraits/Portrait_2.jpg" alt="portrait_2"/>
    </p>
    {
    // email button (CLICK TO COPY)
    }
    <div className="about_me__email_button">
      <div id='copiedMessage_aboutMe'>
        <span className={copiedMessageClass_3} id="copiedMessageSpan_AboutMe">copied {myEmail} to clipboard</span>
      </div>
      <CopyToClipboard text={myEmail} onCopy={onCopy}>
        <a ><img id="about_me__email_button" src="https://s3-us-west-1.amazonaws.com/soniclouds-portfolio-assets/icons/Email_1.png" alt="email_copyclick" className="description__contact_button wow fadeIn" data-wow-offset="450" onClick={contactButtonClicked_aboutMe} /></a>
      </CopyToClipboard>
    </div>

*/}


{/*

    {
    // SKILLS
    }
    {
    // Header
    }
    <h3 className="skills" id="skills">SKILLS</h3>
    {
    // Description and Buttons
    }
    <div className="description_4" id="skills_description">
      <p>
        Specialties include frontend-driven development for web and mobile.  I am also a full-stack developer, which provides me a greater perspective when creating interfaces, and allows me to deliver a complete product, from front to back.
      </p>
      <p className="p_sm">
        I can code in Python, PHP, Objective-C and Swift, but I tend to prefer JavaScript.  My current setup revolves around Node + React/Redux + AWS microservices.  For frontend styling, I use a rotating combination of libraries and frameworks.  I tend to write custom vanilla CSS, but am also equipped to process SASS.  As someone who enjoys ES6, I use Babel as my JavaScript transpiler.  While comfortable with Gulp and Grunt, I tend to prefer using Webpack as my module bundler.  Of course, I am always eager to try out new tools and adopt new set ups as the app demands.
      </p>
      <div className="buttons_container">
        <div id='copiedMessage_Skills'>
          <span className={copiedMessageClass_2} id="copiedMessageSpan_Skills">copied {myEmail} to clipboard</span>
        </div>
        <CopyToClipboard text={myEmail} onCopy={onCopy}>
          <Button color={Colors.SUCCESS} isHollow className="description__contact_button wow fadeIn" data-wow-offset="90" onMouseEnter={contactButtonHover_ON_skills} onMouseLeave={contactButtonHover_OFF_skills} onClick={contactButtonClicked_skills} >{contactMeToggle_2}</Button>
        </CopyToClipboard>
      </div>
    </div>
    {
    // Flying Icons
    }
    <img src="https://s3-us-west-1.amazonaws.com/soniclouds-portfolio-assets/icons/JavaScript_1.png" alt="flyingIcon_Skills_JavaScript" className="flying-icon-2 icon_JavaScript__skills " id="flyingIcon_Skills_JavaScript"/>

    <img src="https://s3-us-west-1.amazonaws.com/soniclouds-portfolio-assets/icons/Swift3_1.png" alt="flyingIcon_Skills_Swift3" className="flying-icon-2 icon_Swift3__skills" id="flyingIcon_Skills_Swift3"/>

    <img src="https://s3-us-west-1.amazonaws.com/soniclouds-portfolio-assets/icons/HTML5_1.png" alt="flyingIcon_Skills_HTML5" className="flying-icon-2 icon_HTML5__skills" id="flyingIcon_Skills_HTML5"/>

    <img src="https://s3-us-west-1.amazonaws.com/soniclouds-portfolio-assets/icons/CSS3_1.png" alt="flyingIcon_Skills_CSS3" className="flying-icon-2 icon_CSS3__skills" id="flyingIcon_Skills_CSS3"/>

    <img src="https://s3-us-west-1.amazonaws.com/soniclouds-portfolio-assets/icons/React_1.png" alt="flyingIcon_Skills_React" className="flying-icon-2 icon_React__skills" id="flyingIcon_Skills_React"/>

    <img src="https://s3-us-west-1.amazonaws.com/soniclouds-portfolio-assets/icons/Redux_1.png" alt="flyingIcon_Skills_Redux" className="flying-icon-2 icon_Redux__skills" id="flyingIcon_Skills_Redux"/>

    <img src="https://s3-us-west-1.amazonaws.com/soniclouds-portfolio-assets/icons/Node_1.png" alt="flyingIcon_Skills_Node" className="flying-icon-2 icon_Node__skills" id="flyingIcon_Skills_Node"/>

    <img src="https://s3-us-west-1.amazonaws.com/soniclouds-portfolio-assets/icons/jQuery_1.png" alt="flyingIcon_Skills_jQuery" className="flying-icon-2 icon_jQuery__skills" id="flyingIcon_Skills_jQuery"/>

    <img src="https://s3-us-west-1.amazonaws.com/soniclouds-portfolio-assets/icons/Angular_1.png" alt="flyingIcon_Skills_Angular" className="flying-icon-2 icon_Angular__skills" id="flyingIcon_Skills_Angular"/>

    <img src="https://s3-us-west-1.amazonaws.com/soniclouds-portfolio-assets/icons/Express_2.png" alt="flyingIcon_Skills_Express" className="flying-icon-2 icon_Express__skills" id="flyingIcon_Skills_Express"/>

    <img src="https://s3-us-west-1.amazonaws.com/soniclouds-portfolio-assets/icons/Xcode_1.png" alt="flyingIcon_Skills_Xcode" className="flying-icon-2 icon_Xcode__skills" id="flyingIcon_Skills_Xcode"/>

    <img src="https://s3-us-west-1.amazonaws.com/soniclouds-portfolio-assets/icons/Foundation_1.png" alt="flyingIcon_Skills_Foundation" className="flying-icon-2 icon_Foundation__skills" id="flyingIcon_Skills_Foundation"/>

    <img src="https://s3-us-west-1.amazonaws.com/soniclouds-portfolio-assets/icons/Webpack_1.png" alt="flyingIcon_Skills_Webpack" className="flying-icon-2 icon_Webpack__skills" id="flyingIcon_Skills_Webpack"/>

    <img src="https://s3-us-west-1.amazonaws.com/soniclouds-portfolio-assets/icons/AWS_3.ico" alt="flyingIcon_Skills_AWS" className="flying-icon-2 icon_AWS__skills" id="flyingIcon_Skills_AWS"/>

    <img src="https://s3-us-west-1.amazonaws.com/soniclouds-portfolio-assets/icons/Mongo_1.png" alt="flyingIcon_Skills_Mongo" className="flying-icon-2 icon_Mongo__skills" id="flyingIcon_Skills_Mongo"/>

    <img src="https://s3-us-west-1.amazonaws.com/soniclouds-portfolio-assets/icons/Babel_1.png" alt="flyingIcon_Skills_Babel" className="flying-icon-2 icon_Babel__skills" id="flyingIcon_Skills_Babel"/>

    <img src="https://s3-us-west-1.amazonaws.com/soniclouds-portfolio-assets/icons/OSX_1.png" alt="flyingIcon_Skills_OSX" className="flying-icon-2 icon_OSX__skills" id="flyingIcon_Skills_OSX"/>

    {
    // NOTE: Still inside of 'about_me__text'
    }
    {
    // MORE ABOUT ME
    }
    {
    // Header
    }
    <div className="about_me__text_header">
      <p className="wow bounceInUp " data-wow-offset="0">M</p><p className="wow bounceInUp " data-wow-offset="60">O</p><p className="wow bounceInUp " data-wow-offset="70">R</p><p className="wow bounceInUp " data-wow-offset="80">E</p> <p className="wow bounceInUp " data-wow-offset="90">A</p><p className="wow bounceInUp  " data-wow-offset="100">B</p><p className="wow bounceInUp  " data-wow-offset="110">O</p><p className="wow bounceInUp  " data-wow-offset="120">U</p><p className="wow bounceInUp  " data-wow-offset="130">T</p> <p className="wow bounceInUp  " data-wow-offset="150">M</p><p className="wow bounceInUp  " data-wow-offset="160">E</p>
    </div>
    {
    // Description and Button
    }
    <div className="description_4 opacity1 wow fadeIn" data-wow-offset="125" id="more_about_me_description">
      <p className="p_more">
        When I’m not coding, I enjoy making music in my home studio, hanging out with my cat, and going on long walks by the coast.  Also, I am obsessed with classical music and outer space.
      </p>
      <Button color={Colors.PRIMARY} isHollow className="links__more">
        <a href="https://www.entrzelle.com">CHECK OUT MY MUSIC</a>
      </Button>
    </div>



  </div>
*/}

</div>

)

export default AboutMe



// WEBPACK FOOTER //
// ./src/components/aboutMe.js